<div class="container-btn-sidebar" [class.isCollapsed]="isCollapsed">
	<button
		pButton
		pRipple
		type="button"
		icon="{{
			isCollapsed ? 'fa-solid fa-angle-right  ' : 'fa-solid fa-angle-left  '
		}}"
		class="p-button-rounded btn-sidebar"
		(click)="toggleSidebar()"
	></button>
</div>

<!-- Sidebar -->

<aside
	#sidebar
	class="sidebar"
	[class.open]="!isCollapsed"
	[class.closed]="isCollapsed"
	[class.mobile]="isMobile"
>
	<ul>
		<ng-container *ngFor="let item of menuItems">
			<li
				*ngIf="shouldDisplay(item)"
				pTooltip="{{ item.label }}"
				tooltipPosition="right"
				[routerLink]="item.route"
				routerLinkActive="active"
				[routerLinkActiveOptions]="item.activeOptions || { exact: false }"
				[ngClass]="{
					active: isActive(item),
					'disabled-feature': item.feature && !hasFeature(item.feature)
				}"
				(click)="onMenuItemClick(item, $event)"
				(mouseenter)="hoveredItem = item"
				(mouseleave)="hoveredItem = null"
			>
				<span class="icon-item">
					<i class="{{ item.icon }}"></i>

					<!-- Badge do carrinho -->
					<i
						class="i-cart"
						*ngIf="item.label === 'Carrinho' && cartTotalItems > 0"
						pBadge
						[value]="cartTotalItems.toFixed(stockDecimalPlaces)"
					></i>

					<!-- Selo PRO (quando a feature não está habilitada) -->

					<ng-container *ngIf="!isCollapsed">
						<p-badge
							class="pro-badge"
							*ngIf="item.feature && !hasFeature(item.feature)"
							value="PRO"
						></p-badge>
					</ng-container>

					<small class="menu-label">
						{{ item.label }}
					</small>
				</span>
			</li>
		</ng-container>
	</ul>
</aside>

<p-menu
	styleClass="p-menu-config"
	#settingsMenu
	[popup]="true"
	[model]="settingsMenuItems"
	[baseZIndex]="10010"
	[autoZIndex]="true"
	appendTo="body"
	(onHide)="onSettingsMenuHide()"
></p-menu>
